import { render, staticRenderFns } from "./OrgAccounts.vue?vue&type=template&id=da127b86&"
import script from "./OrgAccounts.vue?vue&type=script&lang=js&"
export * from "./OrgAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports